var map = {
	"./klim/alert-circle-filled.svg": [
		3502,
		3502
	],
	"./klim/avatar.svg": [
		32361,
		32361
	],
	"./klim/blooming-buds.svg": [
		87882,
		87882
	],
	"./klim/bottle-strikethrough.svg": [
		5076,
		5076
	],
	"./klim/bottle.svg": [
		78998,
		78998
	],
	"./klim/brandmark-with-text.svg": [
		58961,
		58961
	],
	"./klim/brandmark.svg": [
		57150,
		57150
	],
	"./klim/chat.svg": [
		69988,
		69988
	],
	"./klim/checkmark-success.svg": [
		39159,
		39159
	],
	"./klim/co2-emissions.svg": [
		47765,
		47765
	],
	"./klim/compost.svg": [
		1663,
		1663
	],
	"./klim/cow.svg": [
		11851,
		11851
	],
	"./klim/crop-footprint-blue.svg": [
		88319,
		88319
	],
	"./klim/crop-footprint.svg": [
		77614,
		77614
	],
	"./klim/crop-rotation.svg": [
		22223,
		22223
	],
	"./klim/crops-branching.svg": [
		29088,
		29088
	],
	"./klim/crops-emerging.svg": [
		91314,
		91314
	],
	"./klim/crops-matured.svg": [
		19972,
		19972
	],
	"./klim/diagonal-corner-bars.svg": [
		33558,
		33558
	],
	"./klim/edit-element.svg": [
		32321,
		32321
	],
	"./klim/edit.svg": [
		79218,
		79218
	],
	"./klim/energy.svg": [
		56862,
		56862
	],
	"./klim/envelope.svg": [
		29222,
		29222
	],
	"./klim/falling-leaves.svg": [
		31232,
		31232
	],
	"./klim/farm-new.svg": [
		83311,
		83311
	],
	"./klim/farm-size.svg": [
		60312,
		60312
	],
	"./klim/farm.svg": [
		22554,
		22554
	],
	"./klim/farmer.svg": [
		70307,
		70307
	],
	"./klim/fcpo-enrollment.svg": [
		32725,
		32725
	],
	"./klim/fertiliser-strikethrough.svg": [
		81439,
		81439
	],
	"./klim/fertiliser.svg": [
		52709,
		52709
	],
	"./klim/fertilizer.svg": [
		29768,
		29768
	],
	"./klim/field-apply.svg": [
		23389,
		23389
	],
	"./klim/field-size.svg": [
		25480,
		25480
	],
	"./klim/field-split.svg": [
		66749,
		66749
	],
	"./klim/field.svg": [
		13930,
		13930
	],
	"./klim/funding-strikethrough.svg": [
		335,
		335
	],
	"./klim/funding.svg": [
		32757,
		32757
	],
	"./klim/graph.svg": [
		87854,
		87854
	],
	"./klim/heart-handshake.svg": [
		25558,
		3177
	],
	"./klim/klim.svg": [
		21409,
		21409
	],
	"./klim/logo.svg": [
		56519,
		56519
	],
	"./klim/map-pin-plus.svg": [
		36055,
		36055
	],
	"./klim/map-pin.svg": [
		60542,
		60542
	],
	"./klim/medal.svg": [
		74379,
		74379
	],
	"./klim/milk-bottle.svg": [
		39124,
		39124
	],
	"./klim/minus.svg": [
		17234,
		17234
	],
	"./klim/money-plant.svg": [
		23910,
		23910
	],
	"./klim/no-funding.svg": [
		54663,
		54663
	],
	"./klim/page-checkmark.svg": [
		40767,
		40767
	],
	"./klim/panning-crops.svg": [
		40311,
		40311
	],
	"./klim/pesticides.svg": [
		88013,
		88013
	],
	"./klim/plant-ai.svg": [
		38404,
		38404
	],
	"./klim/plant-protection.svg": [
		87839,
		87839
	],
	"./klim/plant.svg": [
		65885,
		65885
	],
	"./klim/planting-plant.svg": [
		12203,
		12203
	],
	"./klim/planting-seeds.svg": [
		76826,
		76826
	],
	"./klim/plus.svg": [
		63962,
		63962
	],
	"./klim/quiz.svg": [
		20941,
		20941
	],
	"./klim/ruler-measure.svg": [
		3837,
		3837
	],
	"./klim/soil-application.svg": [
		24846,
		24846
	],
	"./klim/support-chat.svg": [
		54886,
		54886
	],
	"./klim/template.svg": [
		47676,
		47676
	],
	"./klim/tillage-strikethrough.svg": [
		59030,
		59030
	],
	"./klim/tillage.svg": [
		33928,
		33928
	],
	"./tabler/2fa.svg": [
		45726,
		45726
	],
	"./tabler/3d-cube-sphere.svg": [
		59548,
		59548
	],
	"./tabler/a-b.svg": [
		40923,
		40923
	],
	"./tabler/access-point-off.svg": [
		67398,
		67398
	],
	"./tabler/access-point.svg": [
		48006,
		48006
	],
	"./tabler/accessible.svg": [
		64355,
		64355
	],
	"./tabler/activity.svg": [
		71582,
		71582
	],
	"./tabler/ad-2.svg": [
		61787,
		61787
	],
	"./tabler/ad.svg": [
		2330,
		2330
	],
	"./tabler/adjustments-alt.svg": [
		16229,
		16229
	],
	"./tabler/adjustments-horizontal.svg": [
		7132,
		7132
	],
	"./tabler/adjustments.svg": [
		22923,
		22923
	],
	"./tabler/aerial-lift.svg": [
		11135,
		11135
	],
	"./tabler/affiliate.svg": [
		68690,
		68690
	],
	"./tabler/alarm.svg": [
		21288,
		21288
	],
	"./tabler/alert-circle-filled.svg": [
		95423,
		95423
	],
	"./tabler/alert-circle.svg": [
		66010,
		66010
	],
	"./tabler/alert-octagon.svg": [
		52571,
		52571
	],
	"./tabler/alert-triangle.svg": [
		81922,
		59541
	],
	"./tabler/alien.svg": [
		49230,
		49230
	],
	"./tabler/align-center.svg": [
		77494,
		77494
	],
	"./tabler/align-justified.svg": [
		25424,
		25424
	],
	"./tabler/align-left.svg": [
		51546,
		51546
	],
	"./tabler/align-right.svg": [
		31230,
		8849
	],
	"./tabler/ambulance.svg": [
		56121,
		56121
	],
	"./tabler/anchor.svg": [
		8190,
		8190
	],
	"./tabler/angle.svg": [
		58022,
		58022
	],
	"./tabler/antenna-bars-1.svg": [
		89687,
		89687
	],
	"./tabler/antenna-bars-2.svg": [
		62916,
		62916
	],
	"./tabler/antenna-bars-3.svg": [
		17637,
		17637
	],
	"./tabler/antenna-bars-4.svg": [
		6010,
		6010
	],
	"./tabler/antenna-bars-5.svg": [
		25067,
		25067
	],
	"./tabler/aperture.svg": [
		32325,
		32325
	],
	"./tabler/apple.svg": [
		63267,
		63267
	],
	"./tabler/apps.svg": [
		68933,
		68933
	],
	"./tabler/archive.svg": [
		50721,
		50721
	],
	"./tabler/arrow-back-up.svg": [
		92942,
		92942
	],
	"./tabler/arrow-back.svg": [
		71632,
		71632
	],
	"./tabler/arrow-bar-down.svg": [
		1529,
		1529
	],
	"./tabler/arrow-bar-left.svg": [
		47138,
		47138
	],
	"./tabler/arrow-bar-right.svg": [
		98585,
		98585
	],
	"./tabler/arrow-bar-to-down.svg": [
		11599,
		11599
	],
	"./tabler/arrow-bar-to-left.svg": [
		45488,
		45488
	],
	"./tabler/arrow-bar-to-right.svg": [
		94751,
		94751
	],
	"./tabler/arrow-bar-to-up.svg": [
		36864,
		36864
	],
	"./tabler/arrow-bar-up.svg": [
		49814,
		49814
	],
	"./tabler/arrow-big-down.svg": [
		99706,
		99706
	],
	"./tabler/arrow-big-left.svg": [
		44305,
		44305
	],
	"./tabler/arrow-big-right.svg": [
		36092,
		36092
	],
	"./tabler/arrow-big-top.svg": [
		3387,
		3387
	],
	"./tabler/arrow-bottom-bar.svg": [
		53904,
		53904
	],
	"./tabler/arrow-bottom-circle.svg": [
		97221,
		97221
	],
	"./tabler/arrow-bottom-square.svg": [
		61464,
		61464
	],
	"./tabler/arrow-bottom-tail.svg": [
		37375,
		37375
	],
	"./tabler/arrow-down-circle.svg": [
		46030,
		46030
	],
	"./tabler/arrow-down-left-circle.svg": [
		67218,
		67218
	],
	"./tabler/arrow-down-left.svg": [
		83141,
		83141
	],
	"./tabler/arrow-down-right-circle.svg": [
		1205,
		1205
	],
	"./tabler/arrow-down-right.svg": [
		53832,
		53832
	],
	"./tabler/arrow-down.svg": [
		41425,
		41425
	],
	"./tabler/arrow-forward-up.svg": [
		83434,
		83434
	],
	"./tabler/arrow-forward.svg": [
		96532,
		96532
	],
	"./tabler/arrow-left-bar.svg": [
		82066,
		82066
	],
	"./tabler/arrow-left-circle.svg": [
		78295,
		78295
	],
	"./tabler/arrow-left-square.svg": [
		98662,
		98662
	],
	"./tabler/arrow-left-tail.svg": [
		6325,
		6325
	],
	"./tabler/arrow-left.svg": [
		34506,
		34506
	],
	"./tabler/arrow-loop-left.svg": [
		82171,
		82171
	],
	"./tabler/arrow-loop-right.svg": [
		82622,
		82622
	],
	"./tabler/arrow-narrow-down.svg": [
		66081,
		66081
	],
	"./tabler/arrow-narrow-left.svg": [
		84250,
		84250
	],
	"./tabler/arrow-narrow-right.svg": [
		87281,
		87281
	],
	"./tabler/arrow-narrow-up.svg": [
		28030,
		28030
	],
	"./tabler/arrow-ramp-left.svg": [
		7105,
		7105
	],
	"./tabler/arrow-ramp-right.svg": [
		72268,
		72268
	],
	"./tabler/arrow-right-bar.svg": [
		34857,
		34857
	],
	"./tabler/arrow-right-circle.svg": [
		52094,
		52094
	],
	"./tabler/arrow-right-square.svg": [
		64147,
		64147
	],
	"./tabler/arrow-right-tail.svg": [
		46972,
		46972
	],
	"./tabler/arrow-right.svg": [
		18753,
		18753
	],
	"./tabler/arrow-top-bar.svg": [
		97658,
		97658
	],
	"./tabler/arrow-top-circle.svg": [
		85327,
		85327
	],
	"./tabler/arrow-top-square.svg": [
		21950,
		21950
	],
	"./tabler/arrow-top-tail.svg": [
		27917,
		27917
	],
	"./tabler/arrow-up-circle.svg": [
		92715,
		92715
	],
	"./tabler/arrow-up-left-circle.svg": [
		86805,
		86805
	],
	"./tabler/arrow-up-left.svg": [
		22107,
		44488
	],
	"./tabler/arrow-up-right-circle.svg": [
		38228,
		38228
	],
	"./tabler/arrow-up-right.svg": [
		95799,
		95799
	],
	"./tabler/arrow-up.svg": [
		63630,
		63630
	],
	"./tabler/arrow-wave-left-down.svg": [
		15138,
		92757
	],
	"./tabler/arrow-wave-left-up.svg": [
		84026,
		84026
	],
	"./tabler/arrow-wave-right-down.svg": [
		81472,
		81472
	],
	"./tabler/arrow-wave-right-up.svg": [
		45875,
		45875
	],
	"./tabler/arrows-diagonal-2.svg": [
		32792,
		32792
	],
	"./tabler/arrows-diagonal.svg": [
		34929,
		34929
	],
	"./tabler/arrows-double-ne-sw.svg": [
		66194,
		66194
	],
	"./tabler/arrows-double-nw-se.svg": [
		14542,
		14542
	],
	"./tabler/arrows-double-se-nw.svg": [
		76996,
		76996
	],
	"./tabler/arrows-double-sw-ne.svg": [
		87048,
		87048
	],
	"./tabler/arrows-down-up.svg": [
		43526,
		43526
	],
	"./tabler/arrows-down.svg": [
		36776,
		36776
	],
	"./tabler/arrows-horizontal.svg": [
		19540,
		19540
	],
	"./tabler/arrows-join-2.svg": [
		67745,
		67745
	],
	"./tabler/arrows-join.svg": [
		26428,
		26428
	],
	"./tabler/arrows-left-down.svg": [
		20716,
		20716
	],
	"./tabler/arrows-left-right.svg": [
		42366,
		42366
	],
	"./tabler/arrows-left.svg": [
		4551,
		4551
	],
	"./tabler/arrows-maximize.svg": [
		76938,
		76938
	],
	"./tabler/arrows-minimize.svg": [
		3932,
		3932
	],
	"./tabler/arrows-right-down.svg": [
		5275,
		5275
	],
	"./tabler/arrows-right-left.svg": [
		96860,
		96860
	],
	"./tabler/arrows-right.svg": [
		13282,
		13282
	],
	"./tabler/arrows-sort.svg": [
		33480,
		33480
	],
	"./tabler/arrows-split-2.svg": [
		85529,
		85529
	],
	"./tabler/arrows-split.svg": [
		84804,
		84804
	],
	"./tabler/arrows-up-down.svg": [
		97104,
		97104
	],
	"./tabler/arrows-up-left.svg": [
		57855,
		57855
	],
	"./tabler/arrows-up-right.svg": [
		85914,
		85914
	],
	"./tabler/arrows-up.svg": [
		90523,
		90523
	],
	"./tabler/arrows-vertical.svg": [
		86674,
		86674
	],
	"./tabler/artboard.svg": [
		64832,
		64832
	],
	"./tabler/aspect-ratio.svg": [
		7839,
		7839
	],
	"./tabler/at.svg": [
		60298,
		60298
	],
	"./tabler/atom-2.svg": [
		34623,
		34623
	],
	"./tabler/atom.svg": [
		61014,
		61014
	],
	"./tabler/award.svg": [
		21712,
		21712
	],
	"./tabler/backhoe.svg": [
		63020,
		63020
	],
	"./tabler/backspace.svg": [
		73318,
		73318
	],
	"./tabler/ball-american-football.svg": [
		95905,
		95905
	],
	"./tabler/ball-basketball.svg": [
		80294,
		80294
	],
	"./tabler/ball-bowling.svg": [
		20141,
		20141
	],
	"./tabler/ball-football-off.svg": [
		57056,
		57056
	],
	"./tabler/ball-football.svg": [
		60380,
		60380
	],
	"./tabler/ball-tennis.svg": [
		22562,
		22562
	],
	"./tabler/ball-volleyball.svg": [
		57103,
		57103
	],
	"./tabler/ban.svg": [
		8256,
		8256
	],
	"./tabler/bandage.svg": [
		4253,
		4253
	],
	"./tabler/barcode.svg": [
		85179,
		85179
	],
	"./tabler/basket.svg": [
		5407,
		5407
	],
	"./tabler/battery-1.svg": [
		93070,
		93070
	],
	"./tabler/battery-2.svg": [
		22189,
		22189
	],
	"./tabler/battery-3.svg": [
		42476,
		42476
	],
	"./tabler/battery-4.svg": [
		26515,
		26515
	],
	"./tabler/battery-automotive.svg": [
		98490,
		98490
	],
	"./tabler/battery-charging.svg": [
		33136,
		33136
	],
	"./tabler/battery-off.svg": [
		20260,
		20260
	],
	"./tabler/battery.svg": [
		11648,
		11648
	],
	"./tabler/bed.svg": [
		99894,
		99894
	],
	"./tabler/bell-minus.svg": [
		70877,
		70877
	],
	"./tabler/bell-off.svg": [
		10534,
		10534
	],
	"./tabler/bell-plus.svg": [
		17551,
		17551
	],
	"./tabler/bell-ringing-2.svg": [
		8210,
		8210
	],
	"./tabler/bell-ringing.svg": [
		69223,
		69223
	],
	"./tabler/bell-x.svg": [
		22837,
		22837
	],
	"./tabler/bell.svg": [
		31430,
		31430
	],
	"./tabler/bike.svg": [
		49698,
		49698
	],
	"./tabler/binary.svg": [
		67650,
		67650
	],
	"./tabler/biohazard.svg": [
		71649,
		71649
	],
	"./tabler/blockquote.svg": [
		56048,
		56048
	],
	"./tabler/bluetooth-connected.svg": [
		22123,
		22123
	],
	"./tabler/bluetooth-off.svg": [
		17533,
		17533
	],
	"./tabler/bluetooth.svg": [
		52713,
		52713
	],
	"./tabler/bold.svg": [
		1820,
		1820
	],
	"./tabler/bolt-off.svg": [
		76528,
		76528
	],
	"./tabler/bolt.svg": [
		50764,
		50764
	],
	"./tabler/bone.svg": [
		70147,
		70147
	],
	"./tabler/book.svg": [
		18690,
		18690
	],
	"./tabler/bookmark-off.svg": [
		23177,
		23177
	],
	"./tabler/bookmark.svg": [
		87493,
		87493
	],
	"./tabler/bookmarks.svg": [
		94284,
		94284
	],
	"./tabler/border-all.svg": [
		47777,
		47777
	],
	"./tabler/border-bottom.svg": [
		11953,
		11953
	],
	"./tabler/border-horizontal.svg": [
		81232,
		81232
	],
	"./tabler/border-inner.svg": [
		99331,
		99331
	],
	"./tabler/border-left.svg": [
		50315,
		50315
	],
	"./tabler/border-none.svg": [
		91230,
		91230
	],
	"./tabler/border-outer.svg": [
		54049,
		54049
	],
	"./tabler/border-radius.svg": [
		50610,
		50610
	],
	"./tabler/border-right.svg": [
		72526,
		72526
	],
	"./tabler/border-style-2.svg": [
		88938,
		88938
	],
	"./tabler/border-style.svg": [
		37199,
		37199
	],
	"./tabler/border-top.svg": [
		86473,
		86473
	],
	"./tabler/border-vertical.svg": [
		11446,
		11446
	],
	"./tabler/bottle.svg": [
		73845,
		73845
	],
	"./tabler/box-margin.svg": [
		9551,
		9551
	],
	"./tabler/box-model-2.svg": [
		8413,
		8413
	],
	"./tabler/box-model.svg": [
		59504,
		59504
	],
	"./tabler/box-multiple-0.svg": [
		49486,
		49486
	],
	"./tabler/box-multiple-1.svg": [
		87423,
		87423
	],
	"./tabler/box-multiple-2.svg": [
		24748,
		24748
	],
	"./tabler/box-multiple-3.svg": [
		60205,
		60205
	],
	"./tabler/box-multiple-4.svg": [
		50914,
		50914
	],
	"./tabler/box-multiple-5.svg": [
		65139,
		65139
	],
	"./tabler/box-multiple-6.svg": [
		74400,
		74400
	],
	"./tabler/box-multiple-7.svg": [
		31313,
		31313
	],
	"./tabler/box-multiple-8.svg": [
		33158,
		33158
	],
	"./tabler/box-multiple-9.svg": [
		79607,
		79607
	],
	"./tabler/box-multiple.svg": [
		71597,
		71597
	],
	"./tabler/box-padding.svg": [
		8648,
		8648
	],
	"./tabler/box.svg": [
		52364,
		52364
	],
	"./tabler/braces.svg": [
		88509,
		88509
	],
	"./tabler/brackets.svg": [
		39134,
		39134
	],
	"./tabler/brand-airbnb.svg": [
		15131,
		15131
	],
	"./tabler/brand-android.svg": [
		68486,
		68486
	],
	"./tabler/brand-apple-arcade.svg": [
		30308,
		30308
	],
	"./tabler/brand-apple.svg": [
		47627,
		47627
	],
	"./tabler/brand-appstore.svg": [
		11157,
		11157
	],
	"./tabler/brand-asana.svg": [
		64165,
		64165
	],
	"./tabler/brand-behance.svg": [
		53707,
		53707
	],
	"./tabler/brand-bing.svg": [
		8287,
		8287
	],
	"./tabler/brand-bitbucket.svg": [
		65144,
		65144
	],
	"./tabler/brand-booking.svg": [
		77166,
		77166
	],
	"./tabler/brand-chrome.svg": [
		93303,
		93303
	],
	"./tabler/brand-codepen.svg": [
		18103,
		18103
	],
	"./tabler/brand-codesandbox.svg": [
		71951,
		71951
	],
	"./tabler/brand-css3.svg": [
		48277,
		48277
	],
	"./tabler/brand-deviantart.svg": [
		27493,
		27493
	],
	"./tabler/brand-discord.svg": [
		85947,
		85947
	],
	"./tabler/brand-disqus.svg": [
		5464,
		5464
	],
	"./tabler/brand-docker.svg": [
		75121,
		75121
	],
	"./tabler/brand-dribbble.svg": [
		76379,
		76379
	],
	"./tabler/brand-edge.svg": [
		45546,
		45546
	],
	"./tabler/brand-facebook.svg": [
		67965,
		67965
	],
	"./tabler/brand-figma.svg": [
		8239,
		8239
	],
	"./tabler/brand-firefox.svg": [
		76572,
		76572
	],
	"./tabler/brand-flickr.svg": [
		82860,
		82860
	],
	"./tabler/brand-foursquare.svg": [
		58592,
		58592
	],
	"./tabler/brand-framer.svg": [
		39594,
		39594
	],
	"./tabler/brand-github.svg": [
		88568,
		88568
	],
	"./tabler/brand-gitlab.svg": [
		8656,
		8656
	],
	"./tabler/brand-google-analytics.svg": [
		34355,
		34355
	],
	"./tabler/brand-google-drive.svg": [
		78747,
		78747
	],
	"./tabler/brand-google-play.svg": [
		96379,
		96379
	],
	"./tabler/brand-google.svg": [
		5828,
		5828
	],
	"./tabler/brand-gravatar.svg": [
		56617,
		56617
	],
	"./tabler/brand-hipchat.svg": [
		55370,
		55370
	],
	"./tabler/brand-html5.svg": [
		86811,
		86811
	],
	"./tabler/brand-instagram.svg": [
		40791,
		40791
	],
	"./tabler/brand-javascript.svg": [
		48620,
		48620
	],
	"./tabler/brand-kickstarter.svg": [
		27776,
		27776
	],
	"./tabler/brand-kotlin.svg": [
		14210,
		14210
	],
	"./tabler/brand-linkedin.svg": [
		99299,
		99299
	],
	"./tabler/brand-medium.svg": [
		6972,
		6972
	],
	"./tabler/brand-messenger.svg": [
		21238,
		21238
	],
	"./tabler/brand-netflix.svg": [
		12311,
		12311
	],
	"./tabler/brand-open-source.svg": [
		85929,
		85929
	],
	"./tabler/brand-opera.svg": [
		79418,
		79418
	],
	"./tabler/brand-pagekit.svg": [
		27068,
		27068
	],
	"./tabler/brand-patreon.svg": [
		87376,
		87376
	],
	"./tabler/brand-paypal.svg": [
		4780,
		4780
	],
	"./tabler/brand-pinterest.svg": [
		91309,
		91309
	],
	"./tabler/brand-pocket.svg": [
		62147,
		62147
	],
	"./tabler/brand-producthunt.svg": [
		68561,
		68561
	],
	"./tabler/brand-python.svg": [
		58863,
		58863
	],
	"./tabler/brand-reddit.svg": [
		32797,
		32797
	],
	"./tabler/brand-safari.svg": [
		55585,
		55585
	],
	"./tabler/brand-sass.svg": [
		74259,
		74259
	],
	"./tabler/brand-sentry.svg": [
		48324,
		48324
	],
	"./tabler/brand-shazam.svg": [
		67339,
		67339
	],
	"./tabler/brand-sketch.svg": [
		37721,
		37721
	],
	"./tabler/brand-skype.svg": [
		27685,
		27685
	],
	"./tabler/brand-slack.svg": [
		84151,
		84151
	],
	"./tabler/brand-snapchat.svg": [
		39287,
		39287
	],
	"./tabler/brand-soundcloud.svg": [
		47685,
		47685
	],
	"./tabler/brand-spotify.svg": [
		6137,
		6137
	],
	"./tabler/brand-steam.svg": [
		97315,
		97315
	],
	"./tabler/brand-stripe.svg": [
		80022,
		80022
	],
	"./tabler/brand-tabler.svg": [
		35887,
		35887
	],
	"./tabler/brand-tailwind.svg": [
		68609,
		68609
	],
	"./tabler/brand-telegram.svg": [
		4068,
		4068
	],
	"./tabler/brand-tidal.svg": [
		86455,
		86455
	],
	"./tabler/brand-tiktok.svg": [
		70351,
		70351
	],
	"./tabler/brand-tinder.svg": [
		96099,
		96099
	],
	"./tabler/brand-tumblr.svg": [
		83211,
		83211
	],
	"./tabler/brand-twitch.svg": [
		38480,
		38480
	],
	"./tabler/brand-twitter.svg": [
		77338,
		77338
	],
	"./tabler/brand-unsplash.svg": [
		81721,
		81721
	],
	"./tabler/brand-vercel.svg": [
		36068,
		36068
	],
	"./tabler/brand-vimeo.svg": [
		99855,
		99855
	],
	"./tabler/brand-vk.svg": [
		84108,
		84108
	],
	"./tabler/brand-whatsapp.svg": [
		54943,
		54943
	],
	"./tabler/brand-windows.svg": [
		89624,
		89624
	],
	"./tabler/brand-yahoo.svg": [
		6199,
		6199
	],
	"./tabler/brand-ycombinator.svg": [
		45840,
		45840
	],
	"./tabler/brand-youtube.svg": [
		70432,
		70432
	],
	"./tabler/briefcase.svg": [
		93651,
		93651
	],
	"./tabler/brightness-2.svg": [
		85117,
		85117
	],
	"./tabler/brightness-down.svg": [
		11153,
		11153
	],
	"./tabler/brightness-half.svg": [
		32902,
		32902
	],
	"./tabler/brightness-up.svg": [
		5710,
		5710
	],
	"./tabler/brightness.svg": [
		64400,
		64400
	],
	"./tabler/browser.svg": [
		10651,
		10651
	],
	"./tabler/brush.svg": [
		23443,
		23443
	],
	"./tabler/bucket.svg": [
		2955,
		2955
	],
	"./tabler/bug.svg": [
		60773,
		60773
	],
	"./tabler/building-arch.svg": [
		96378,
		96378
	],
	"./tabler/building-bank.svg": [
		89392,
		89392
	],
	"./tabler/building-bridge-2.svg": [
		81788,
		81788
	],
	"./tabler/building-bridge.svg": [
		70429,
		70429
	],
	"./tabler/building-carousel.svg": [
		67832,
		67832
	],
	"./tabler/building-castle.svg": [
		19102,
		19102
	],
	"./tabler/building-church.svg": [
		42079,
		42079
	],
	"./tabler/building-community.svg": [
		41697,
		41697
	],
	"./tabler/building-cottage.svg": [
		51569,
		51569
	],
	"./tabler/building-factory.svg": [
		22872,
		22872
	],
	"./tabler/building-fortress.svg": [
		78760,
		78760
	],
	"./tabler/building-hospital.svg": [
		12100,
		12100
	],
	"./tabler/building-lighthouse.svg": [
		94566,
		94566
	],
	"./tabler/building-monument.svg": [
		36029,
		36029
	],
	"./tabler/building-pavilon.svg": [
		32595,
		32595
	],
	"./tabler/building-skyscraper.svg": [
		66817,
		66817
	],
	"./tabler/building-store.svg": [
		91461,
		91461
	],
	"./tabler/building-warehouse.svg": [
		78431,
		78431
	],
	"./tabler/building.svg": [
		34365,
		34365
	],
	"./tabler/bulb-off.svg": [
		15860,
		15860
	],
	"./tabler/bulb.svg": [
		24272,
		24272
	],
	"./tabler/bulldozer.svg": [
		4612,
		4612
	],
	"./tabler/bus.svg": [
		9817,
		9817
	],
	"./tabler/businessplan.svg": [
		44918,
		44918
	],
	"./tabler/calculator.svg": [
		55681,
		55681
	],
	"./tabler/calendar-event.svg": [
		82100,
		82100
	],
	"./tabler/calendar-minus.svg": [
		68932,
		68932
	],
	"./tabler/calendar-off.svg": [
		16219,
		16219
	],
	"./tabler/calendar-plus.svg": [
		15628,
		15628
	],
	"./tabler/calendar-stats.svg": [
		9637,
		9637
	],
	"./tabler/calendar-time.svg": [
		50039,
		50039
	],
	"./tabler/calendar.svg": [
		50675,
		50675
	],
	"./tabler/camera-minus.svg": [
		33651,
		33651
	],
	"./tabler/camera-off.svg": [
		26800,
		26800
	],
	"./tabler/camera-plus.svg": [
		21717,
		21717
	],
	"./tabler/camera-rotate.svg": [
		64384,
		64384
	],
	"./tabler/camera-selfie.svg": [
		1017,
		1017
	],
	"./tabler/camera.svg": [
		96268,
		96268
	],
	"./tabler/candy.svg": [
		61608,
		61608
	],
	"./tabler/capture.svg": [
		40449,
		40449
	],
	"./tabler/car-crane.svg": [
		49221,
		49221
	],
	"./tabler/car.svg": [
		38457,
		38457
	],
	"./tabler/caravan.svg": [
		2605,
		2605
	],
	"./tabler/cardboards.svg": [
		9376,
		9376
	],
	"./tabler/caret-down.svg": [
		78639,
		78639
	],
	"./tabler/caret-left.svg": [
		87824,
		87824
	],
	"./tabler/caret-right.svg": [
		68287,
		68287
	],
	"./tabler/caret-up.svg": [
		14144,
		14144
	],
	"./tabler/cash-banknote-off.svg": [
		10671,
		10671
	],
	"./tabler/cash-banknote.svg": [
		29431,
		29431
	],
	"./tabler/cash.svg": [
		192,
		192
	],
	"./tabler/cast.svg": [
		28564,
		28564
	],
	"./tabler/ce.svg": [
		47941,
		47941
	],
	"./tabler/certificate.svg": [
		7398,
		7398
	],
	"./tabler/charging-pile.svg": [
		51217,
		51217
	],
	"./tabler/chart-arcs-3.svg": [
		85407,
		85407
	],
	"./tabler/chart-arcs.svg": [
		9163,
		9163
	],
	"./tabler/chart-area-line.svg": [
		54434,
		54434
	],
	"./tabler/chart-area.svg": [
		51915,
		51915
	],
	"./tabler/chart-arrows-vertical.svg": [
		81829,
		81829
	],
	"./tabler/chart-arrows.svg": [
		59541,
		81922
	],
	"./tabler/chart-bar.svg": [
		21719,
		21719
	],
	"./tabler/chart-bubble.svg": [
		2066,
		2066
	],
	"./tabler/chart-candle.svg": [
		59279,
		59279
	],
	"./tabler/chart-circles.svg": [
		34551,
		34551
	],
	"./tabler/chart-donut-2.svg": [
		33273,
		33273
	],
	"./tabler/chart-donut-3.svg": [
		51528,
		51528
	],
	"./tabler/chart-donut-4.svg": [
		89127,
		89127
	],
	"./tabler/chart-donut.svg": [
		12804,
		12804
	],
	"./tabler/chart-dots.svg": [
		48244,
		48244
	],
	"./tabler/chart-infographic.svg": [
		87424,
		87424
	],
	"./tabler/chart-line.svg": [
		13022,
		13022
	],
	"./tabler/chart-pie-2.svg": [
		14983,
		14983
	],
	"./tabler/chart-pie-3.svg": [
		27862,
		27862
	],
	"./tabler/chart-pie-4.svg": [
		3097,
		3097
	],
	"./tabler/chart-pie.svg": [
		83630,
		83630
	],
	"./tabler/chart-radar.svg": [
		37668,
		37668
	],
	"./tabler/check.svg": [
		59207,
		59207
	],
	"./tabler/checkbox.svg": [
		44934,
		44934
	],
	"./tabler/checks.svg": [
		86294,
		86294
	],
	"./tabler/cheese.svg": [
		24226,
		24226
	],
	"./tabler/chevron-down-left.svg": [
		54287,
		54287
	],
	"./tabler/chevron-down-right.svg": [
		32298,
		32298
	],
	"./tabler/chevron-down.svg": [
		81515,
		81515
	],
	"./tabler/chevron-left.svg": [
		64844,
		64844
	],
	"./tabler/chevron-right.svg": [
		68947,
		68947
	],
	"./tabler/chevron-up-left.svg": [
		48270,
		48270
	],
	"./tabler/chevron-up-right.svg": [
		13037,
		13037
	],
	"./tabler/chevron-up.svg": [
		2020,
		2020
	],
	"./tabler/chevrons-down-left.svg": [
		95172,
		95172
	],
	"./tabler/chevrons-down-right.svg": [
		75435,
		75435
	],
	"./tabler/chevrons-down.svg": [
		33466,
		33466
	],
	"./tabler/chevrons-left.svg": [
		8913,
		8913
	],
	"./tabler/chevrons-right.svg": [
		45276,
		45276
	],
	"./tabler/chevrons-up-left.svg": [
		54317,
		54317
	],
	"./tabler/chevrons-up-right.svg": [
		57968,
		57968
	],
	"./tabler/chevrons-up.svg": [
		60105,
		60105
	],
	"./tabler/christmas-tree.svg": [
		29384,
		29384
	],
	"./tabler/circle-0.svg": [
		64298,
		64298
	],
	"./tabler/circle-1.svg": [
		6267,
		6267
	],
	"./tabler/circle-2.svg": [
		24904,
		24904
	],
	"./tabler/circle-3.svg": [
		6649,
		6649
	],
	"./tabler/circle-4.svg": [
		22966,
		22966
	],
	"./tabler/circle-5.svg": [
		62503,
		62503
	],
	"./tabler/circle-6.svg": [
		74644,
		52263
	],
	"./tabler/circle-7.svg": [
		35925,
		35925
	],
	"./tabler/circle-8.svg": [
		98642,
		98642
	],
	"./tabler/circle-9.svg": [
		48035,
		48035
	],
	"./tabler/circle-check-filled.svg": [
		88115,
		88115
	],
	"./tabler/circle-check.svg": [
		78294,
		78294
	],
	"./tabler/circle-dashed.svg": [
		28889,
		28889
	],
	"./tabler/circle-dotted.svg": [
		42074,
		42074
	],
	"./tabler/circle-half-vertical.svg": [
		72884,
		72884
	],
	"./tabler/circle-half.svg": [
		93061,
		93061
	],
	"./tabler/circle-minus.svg": [
		75682,
		75682
	],
	"./tabler/circle-off.svg": [
		13045,
		13045
	],
	"./tabler/circle-plus.svg": [
		43498,
		43498
	],
	"./tabler/circle-square.svg": [
		12563,
		12563
	],
	"./tabler/circle-x.svg": [
		71794,
		71794
	],
	"./tabler/circle.svg": [
		57665,
		57665
	],
	"./tabler/circles.svg": [
		83888,
		83888
	],
	"./tabler/clear-all.svg": [
		15434,
		15434
	],
	"./tabler/clear-formatting.svg": [
		4680,
		4680
	],
	"./tabler/click.svg": [
		35111,
		35111
	],
	"./tabler/clipboard-check.svg": [
		6966,
		6966
	],
	"./tabler/clipboard-list.svg": [
		47842,
		47842
	],
	"./tabler/clipboard-x.svg": [
		64914,
		64914
	],
	"./tabler/clipboard.svg": [
		51297,
		51297
	],
	"./tabler/clock.svg": [
		99693,
		99693
	],
	"./tabler/cloud-download.svg": [
		1313,
		1313
	],
	"./tabler/cloud-fog.svg": [
		26227,
		26227
	],
	"./tabler/cloud-off.svg": [
		22436,
		22436
	],
	"./tabler/cloud-rain.svg": [
		60607,
		60607
	],
	"./tabler/cloud-snow.svg": [
		42932,
		42932
	],
	"./tabler/cloud-storm.svg": [
		59144,
		59144
	],
	"./tabler/cloud-upload.svg": [
		61174,
		61174
	],
	"./tabler/cloud.svg": [
		33216,
		33216
	],
	"./tabler/code-minus.svg": [
		7413,
		7413
	],
	"./tabler/code-plus.svg": [
		20983,
		20983
	],
	"./tabler/code.svg": [
		26494,
		26494
	],
	"./tabler/coffee.svg": [
		2517,
		2517
	],
	"./tabler/coin.svg": [
		52346,
		52346
	],
	"./tabler/color-picker.svg": [
		82157,
		82157
	],
	"./tabler/color-swatch.svg": [
		13459,
		13459
	],
	"./tabler/column-insert-left.svg": [
		49183,
		49183
	],
	"./tabler/column-insert-right.svg": [
		30170,
		7789
	],
	"./tabler/columns.svg": [
		2578,
		2578
	],
	"./tabler/comet.svg": [
		24195,
		24195
	],
	"./tabler/command.svg": [
		81368,
		81368
	],
	"./tabler/compass.svg": [
		91947,
		91947
	],
	"./tabler/confetti.svg": [
		1393,
		1393
	],
	"./tabler/container.svg": [
		19346,
		19346
	],
	"./tabler/contrast.svg": [
		90927,
		90927
	],
	"./tabler/cookie.svg": [
		88911,
		88911
	],
	"./tabler/copy.svg": [
		49918,
		49918
	],
	"./tabler/copyleft.svg": [
		27581,
		27581
	],
	"./tabler/copyright.svg": [
		30080,
		30080
	],
	"./tabler/corner-down-left-double.svg": [
		74747,
		74747
	],
	"./tabler/corner-down-left.svg": [
		9635,
		9635
	],
	"./tabler/corner-down-right-double.svg": [
		39464,
		39464
	],
	"./tabler/corner-down-right.svg": [
		30598,
		30598
	],
	"./tabler/corner-left-down-double.svg": [
		1669,
		1669
	],
	"./tabler/corner-left-down.svg": [
		60385,
		60385
	],
	"./tabler/corner-left-up-double.svg": [
		90144,
		90144
	],
	"./tabler/corner-left-up.svg": [
		17214,
		17214
	],
	"./tabler/corner-right-down-double.svg": [
		56482,
		56482
	],
	"./tabler/corner-right-down.svg": [
		60084,
		60084
	],
	"./tabler/corner-right-up-double.svg": [
		51503,
		51503
	],
	"./tabler/corner-right-up.svg": [
		61295,
		61295
	],
	"./tabler/corner-up-left-double.svg": [
		46100,
		46100
	],
	"./tabler/corner-up-left.svg": [
		3658,
		3658
	],
	"./tabler/corner-up-right-double.svg": [
		16485,
		16485
	],
	"./tabler/corner-up-right.svg": [
		50113,
		50113
	],
	"./tabler/crane.svg": [
		96612,
		96612
	],
	"./tabler/credit-card-off.svg": [
		10841,
		10841
	],
	"./tabler/credit-card.svg": [
		73781,
		73781
	],
	"./tabler/crop.svg": [
		80115,
		80115
	],
	"./tabler/crosshair.svg": [
		78727,
		78727
	],
	"./tabler/crown-off.svg": [
		77682,
		77682
	],
	"./tabler/crown.svg": [
		47714,
		47714
	],
	"./tabler/cup.svg": [
		63087,
		63087
	],
	"./tabler/curly-loop.svg": [
		37687,
		37687
	],
	"./tabler/currency-bahraini.svg": [
		28533,
		28533
	],
	"./tabler/currency-bath.svg": [
		71146,
		71146
	],
	"./tabler/currency-bitcoin.svg": [
		90961,
		90961
	],
	"./tabler/currency-cent.svg": [
		93939,
		93939
	],
	"./tabler/currency-dinar.svg": [
		62155,
		62155
	],
	"./tabler/currency-dirham.svg": [
		48764,
		48764
	],
	"./tabler/currency-dollar-australian.svg": [
		12716,
		12716
	],
	"./tabler/currency-dollar-canadian.svg": [
		7419,
		7419
	],
	"./tabler/currency-dollar-singapore.svg": [
		16186,
		16186
	],
	"./tabler/currency-dollar.svg": [
		86275,
		86275
	],
	"./tabler/currency-ethereum.svg": [
		9282,
		9282
	],
	"./tabler/currency-euro.svg": [
		2638,
		2638
	],
	"./tabler/currency-forint.svg": [
		50673,
		50673
	],
	"./tabler/currency-frank.svg": [
		52635,
		52635
	],
	"./tabler/currency-krone-czech.svg": [
		71428,
		71428
	],
	"./tabler/currency-krone-danish.svg": [
		89264,
		89264
	],
	"./tabler/currency-krone-swedish.svg": [
		92562,
		92562
	],
	"./tabler/currency-leu.svg": [
		93345,
		93345
	],
	"./tabler/currency-lira.svg": [
		65551,
		65551
	],
	"./tabler/currency-litecoin.svg": [
		36986,
		36986
	],
	"./tabler/currency-naira.svg": [
		59092,
		59092
	],
	"./tabler/currency-pound.svg": [
		29185,
		29185
	],
	"./tabler/currency-real.svg": [
		27833,
		27833
	],
	"./tabler/currency-renminbi.svg": [
		94779,
		94779
	],
	"./tabler/currency-ripple.svg": [
		86639,
		86639
	],
	"./tabler/currency-riyal.svg": [
		98796,
		98796
	],
	"./tabler/currency-rubel.svg": [
		18207,
		18207
	],
	"./tabler/currency-rupee.svg": [
		3328,
		3328
	],
	"./tabler/currency-shekel.svg": [
		70971,
		70971
	],
	"./tabler/currency-taka.svg": [
		21504,
		21504
	],
	"./tabler/currency-tugrik.svg": [
		63227,
		63227
	],
	"./tabler/currency-won.svg": [
		74363,
		74363
	],
	"./tabler/currency-yen.svg": [
		62491,
		62491
	],
	"./tabler/currency-zloty.svg": [
		71691,
		71691
	],
	"./tabler/current-location.svg": [
		96684,
		96684
	],
	"./tabler/cursor-text.svg": [
		19977,
		19977
	],
	"./tabler/cut.svg": [
		42339,
		42339
	],
	"./tabler/dashboard.svg": [
		89599,
		89599
	],
	"./tabler/database-export.svg": [
		22045,
		22045
	],
	"./tabler/database-import.svg": [
		87648,
		87648
	],
	"./tabler/database-off.svg": [
		71546,
		71546
	],
	"./tabler/database.svg": [
		95594,
		95594
	],
	"./tabler/details.svg": [
		18265,
		18265
	],
	"./tabler/device-analytics.svg": [
		18380,
		18380
	],
	"./tabler/device-audio-tape.svg": [
		90179,
		90179
	],
	"./tabler/device-cctv.svg": [
		75356,
		75356
	],
	"./tabler/device-computer-camera-off.svg": [
		32753,
		32753
	],
	"./tabler/device-computer-camera.svg": [
		14285,
		14285
	],
	"./tabler/device-desktop-analytics.svg": [
		47699,
		47699
	],
	"./tabler/device-desktop-off.svg": [
		36040,
		36040
	],
	"./tabler/device-desktop.svg": [
		62372,
		62372
	],
	"./tabler/device-floppy.svg": [
		53330,
		53330
	],
	"./tabler/device-gamepad.svg": [
		30525,
		30525
	],
	"./tabler/device-laptop.svg": [
		99440,
		99440
	],
	"./tabler/device-mobile-message.svg": [
		33808,
		33808
	],
	"./tabler/device-mobile-rotated.svg": [
		90458,
		90458
	],
	"./tabler/device-mobile-vibration.svg": [
		85503,
		85503
	],
	"./tabler/device-mobile.svg": [
		88586,
		88586
	],
	"./tabler/device-speaker.svg": [
		1983,
		1983
	],
	"./tabler/device-tablet.svg": [
		52263,
		74644
	],
	"./tabler/device-tv.svg": [
		12798,
		12798
	],
	"./tabler/device-watch.svg": [
		34389,
		34389
	],
	"./tabler/devices-2.svg": [
		17427,
		17427
	],
	"./tabler/devices-pc.svg": [
		3120,
		3120
	],
	"./tabler/devices.svg": [
		63682,
		63682
	],
	"./tabler/diamond.svg": [
		11667,
		11667
	],
	"./tabler/dice.svg": [
		81544,
		81544
	],
	"./tabler/dimensions.svg": [
		43462,
		43462
	],
	"./tabler/direction-horizontal.svg": [
		15377,
		15377
	],
	"./tabler/direction.svg": [
		67924,
		67924
	],
	"./tabler/directions.svg": [
		75935,
		75935
	],
	"./tabler/disabled-2.svg": [
		99648,
		99648
	],
	"./tabler/disabled.svg": [
		57449,
		57449
	],
	"./tabler/disc.svg": [
		48454,
		48454
	],
	"./tabler/discount-2.svg": [
		51281,
		51281
	],
	"./tabler/discount.svg": [
		38188,
		38188
	],
	"./tabler/divide.svg": [
		57534,
		57534
	],
	"./tabler/dna.svg": [
		25896,
		25896
	],
	"./tabler/dog-bowl.svg": [
		88906,
		88906
	],
	"./tabler/dots-circle-horizontal.svg": [
		49599,
		49599
	],
	"./tabler/dots-diagonal-2.svg": [
		65046,
		65046
	],
	"./tabler/dots-diagonal.svg": [
		4515,
		4515
	],
	"./tabler/dots-vertical.svg": [
		67900,
		67900
	],
	"./tabler/dots.svg": [
		73069,
		73069
	],
	"./tabler/download.svg": [
		38013,
		38013
	],
	"./tabler/drag-drop-2.svg": [
		2886,
		2886
	],
	"./tabler/drag-drop.svg": [
		5715,
		5715
	],
	"./tabler/drone-off.svg": [
		55001,
		55001
	],
	"./tabler/drone.svg": [
		96757,
		96757
	],
	"./tabler/droplet-filled-2.svg": [
		43691,
		43691
	],
	"./tabler/droplet-filled.svg": [
		10,
		10
	],
	"./tabler/droplet-half-2.svg": [
		8076,
		8076
	],
	"./tabler/droplet-half.svg": [
		98221,
		98221
	],
	"./tabler/droplet-off.svg": [
		63325,
		63325
	],
	"./tabler/droplet.svg": [
		97673,
		97673
	],
	"./tabler/ear-off.svg": [
		8427,
		8427
	],
	"./tabler/ear.svg": [
		86979,
		86979
	],
	"./tabler/edit-circle.svg": [
		69410,
		69410
	],
	"./tabler/edit.svg": [
		78485,
		78485
	],
	"./tabler/egg.svg": [
		26112,
		26112
	],
	"./tabler/emphasis.svg": [
		47831,
		47831
	],
	"./tabler/equal-not.svg": [
		13487,
		13487
	],
	"./tabler/equal.svg": [
		91707,
		91707
	],
	"./tabler/eraser.svg": [
		39357,
		39357
	],
	"./tabler/exchange.svg": [
		25646,
		25646
	],
	"./tabler/exposure.svg": [
		4710,
		4710
	],
	"./tabler/external-link.svg": [
		81105,
		81105
	],
	"./tabler/eye-check.svg": [
		74407,
		74407
	],
	"./tabler/eye-off.svg": [
		68632,
		68632
	],
	"./tabler/eye.svg": [
		71956,
		71956
	],
	"./tabler/eyeglass-2.svg": [
		52357,
		52357
	],
	"./tabler/eyeglass.svg": [
		12040,
		12040
	],
	"./tabler/face-id.svg": [
		32568,
		32568
	],
	"./tabler/fall.svg": [
		75998,
		75998
	],
	"./tabler/feather.svg": [
		98566,
		98566
	],
	"./tabler/fence.svg": [
		24396,
		24396
	],
	"./tabler/file-alert.svg": [
		84610,
		84610
	],
	"./tabler/file-analytics.svg": [
		73136,
		73136
	],
	"./tabler/file-certificate.svg": [
		94173,
		94173
	],
	"./tabler/file-check.svg": [
		98320,
		98320
	],
	"./tabler/file-code-2.svg": [
		24722,
		24722
	],
	"./tabler/file-code.svg": [
		34311,
		34311
	],
	"./tabler/file-diff.svg": [
		83277,
		83277
	],
	"./tabler/file-dislike.svg": [
		76909,
		76909
	],
	"./tabler/file-download.svg": [
		5400,
		5400
	],
	"./tabler/file-export.svg": [
		54378,
		54378
	],
	"./tabler/file-horizontal.svg": [
		84376,
		84376
	],
	"./tabler/file-import.svg": [
		62255,
		62255
	],
	"./tabler/file-info.svg": [
		6036,
		6036
	],
	"./tabler/file-invoice.svg": [
		21721,
		21721
	],
	"./tabler/file-like.svg": [
		24473,
		24473
	],
	"./tabler/file-minus.svg": [
		35120,
		35120
	],
	"./tabler/file-music.svg": [
		10329,
		10329
	],
	"./tabler/file-off.svg": [
		72999,
		72999
	],
	"./tabler/file-phone.svg": [
		12996,
		12996
	],
	"./tabler/file-plus.svg": [
		32760,
		32760
	],
	"./tabler/file-report.svg": [
		80718,
		80718
	],
	"./tabler/file-search.svg": [
		70964,
		70964
	],
	"./tabler/file-shredder.svg": [
		62215,
		62215
	],
	"./tabler/file-symlink.svg": [
		75025,
		75025
	],
	"./tabler/file-text.svg": [
		66301,
		66301
	],
	"./tabler/file-upload.svg": [
		57267,
		57267
	],
	"./tabler/file-x.svg": [
		41264,
		41264
	],
	"./tabler/file-zip.svg": [
		75701,
		75701
	],
	"./tabler/file.svg": [
		64111,
		64111
	],
	"./tabler/files-off.svg": [
		24238,
		24238
	],
	"./tabler/files.svg": [
		94350,
		94350
	],
	"./tabler/filter-off.svg": [
		60631,
		60631
	],
	"./tabler/filter.svg": [
		78879,
		78879
	],
	"./tabler/fingerprint.svg": [
		71943,
		71943
	],
	"./tabler/firetruck.svg": [
		83326,
		83326
	],
	"./tabler/fish.svg": [
		30307,
		30307
	],
	"./tabler/flag-2.svg": [
		38314,
		38314
	],
	"./tabler/flag-3.svg": [
		80283,
		80283
	],
	"./tabler/flag.svg": [
		18063,
		18063
	],
	"./tabler/flame.svg": [
		10914,
		10914
	],
	"./tabler/flare.svg": [
		59795,
		59795
	],
	"./tabler/flask.svg": [
		11090,
		11090
	],
	"./tabler/flip-horizontal.svg": [
		7453,
		7453
	],
	"./tabler/flip-vertical.svg": [
		10043,
		10043
	],
	"./tabler/float-center.svg": [
		27497,
		27497
	],
	"./tabler/float-left.svg": [
		93633,
		93633
	],
	"./tabler/float-none.svg": [
		91148,
		91148
	],
	"./tabler/float-right.svg": [
		57484,
		35103
	],
	"./tabler/focus-2.svg": [
		65986,
		65986
	],
	"./tabler/focus.svg": [
		13303,
		13303
	],
	"./tabler/fold-down.svg": [
		39913,
		39913
	],
	"./tabler/fold-up.svg": [
		15046,
		15046
	],
	"./tabler/fold.svg": [
		5736,
		5736
	],
	"./tabler/folder-minus.svg": [
		28910,
		28910
	],
	"./tabler/folder-off.svg": [
		36625,
		36625
	],
	"./tabler/folder-plus.svg": [
		42918,
		42918
	],
	"./tabler/folder-x.svg": [
		42982,
		42982
	],
	"./tabler/folder.svg": [
		88909,
		88909
	],
	"./tabler/folders.svg": [
		68324,
		68324
	],
	"./tabler/forbid-2.svg": [
		66214,
		66214
	],
	"./tabler/forbid.svg": [
		90227,
		90227
	],
	"./tabler/forklift.svg": [
		30334,
		30334
	],
	"./tabler/forms.svg": [
		72650,
		72650
	],
	"./tabler/frame.svg": [
		17120,
		17120
	],
	"./tabler/friends.svg": [
		45156,
		45156
	],
	"./tabler/gas-station.svg": [
		68011,
		68011
	],
	"./tabler/gauge.svg": [
		69926,
		69926
	],
	"./tabler/geometry.svg": [
		36753,
		36753
	],
	"./tabler/ghost.svg": [
		77954,
		77954
	],
	"./tabler/gift.svg": [
		51583,
		51583
	],
	"./tabler/git-branch.svg": [
		92244,
		92244
	],
	"./tabler/git-commit.svg": [
		70771,
		70771
	],
	"./tabler/git-compare.svg": [
		377,
		377
	],
	"./tabler/git-fork.svg": [
		74424,
		74424
	],
	"./tabler/git-merge.svg": [
		3408,
		3408
	],
	"./tabler/git-pull-request.svg": [
		54245,
		54245
	],
	"./tabler/glass-full.svg": [
		21219,
		21219
	],
	"./tabler/glass-off.svg": [
		13123,
		13123
	],
	"./tabler/glass.svg": [
		29563,
		29563
	],
	"./tabler/globe.svg": [
		35232,
		35232
	],
	"./tabler/golf.svg": [
		58625,
		58625
	],
	"./tabler/gps.svg": [
		84999,
		84999
	],
	"./tabler/grain.svg": [
		42150,
		42150
	],
	"./tabler/grid-dots.svg": [
		69766,
		47385
	],
	"./tabler/grip-horizontal.svg": [
		29922,
		29922
	],
	"./tabler/grip-vertical.svg": [
		97616,
		97616
	],
	"./tabler/growth.svg": [
		73100,
		73100
	],
	"./tabler/h-1.svg": [
		59509,
		59509
	],
	"./tabler/h-2.svg": [
		87638,
		87638
	],
	"./tabler/h-3.svg": [
		51463,
		51463
	],
	"./tabler/h-4.svg": [
		62280,
		62280
	],
	"./tabler/h-5.svg": [
		44025,
		44025
	],
	"./tabler/h-6.svg": [
		52650,
		52650
	],
	"./tabler/hand-finger.svg": [
		2180,
		2180
	],
	"./tabler/hand-little-finger.svg": [
		66607,
		66607
	],
	"./tabler/hand-middle-finger.svg": [
		882,
		882
	],
	"./tabler/hand-off.svg": [
		19918,
		19918
	],
	"./tabler/hand-ring-finger.svg": [
		16337,
		16337
	],
	"./tabler/hand-rock.svg": [
		7004,
		7004
	],
	"./tabler/hand-stop.svg": [
		41943,
		41943
	],
	"./tabler/hand-three-fingers.svg": [
		84872,
		84872
	],
	"./tabler/hand-two-fingers.svg": [
		59254,
		59254
	],
	"./tabler/hanger.svg": [
		31540,
		31540
	],
	"./tabler/hash.svg": [
		26553,
		26553
	],
	"./tabler/heading.svg": [
		59565,
		59565
	],
	"./tabler/headphones-off.svg": [
		80444,
		80444
	],
	"./tabler/headphones.svg": [
		69912,
		69912
	],
	"./tabler/headset.svg": [
		3157,
		3157
	],
	"./tabler/heart-broken.svg": [
		76531,
		76531
	],
	"./tabler/heart.svg": [
		10515,
		10515
	],
	"./tabler/helicopter-landing.svg": [
		17268,
		17268
	],
	"./tabler/helicopter.svg": [
		89550,
		89550
	],
	"./tabler/help.svg": [
		6008,
		6008
	],
	"./tabler/hexagon-off.svg": [
		35363,
		35363
	],
	"./tabler/hexagon.svg": [
		21723,
		21723
	],
	"./tabler/hierarchy-2.svg": [
		57115,
		57115
	],
	"./tabler/hierarchy.svg": [
		34202,
		11821
	],
	"./tabler/history.svg": [
		76607,
		76607
	],
	"./tabler/home-2.svg": [
		39797,
		39797
	],
	"./tabler/home.svg": [
		3512,
		3512
	],
	"./tabler/ice-cream-2.svg": [
		56542,
		56542
	],
	"./tabler/ice-cream.svg": [
		98971,
		98971
	],
	"./tabler/id.svg": [
		45746,
		45746
	],
	"./tabler/inbox.svg": [
		37448,
		15067
	],
	"./tabler/indent-decrease.svg": [
		98480,
		98480
	],
	"./tabler/indent-increase.svg": [
		76124,
		76124
	],
	"./tabler/infinity.svg": [
		66809,
		66809
	],
	"./tabler/info-circle.svg": [
		1658,
		1658
	],
	"./tabler/info-square.svg": [
		11903,
		11903
	],
	"./tabler/italic.svg": [
		86541,
		86541
	],
	"./tabler/jump-rope.svg": [
		93422,
		93422
	],
	"./tabler/karate.svg": [
		99,
		99
	],
	"./tabler/key.svg": [
		33118,
		33118
	],
	"./tabler/keyboard-hide.svg": [
		83615,
		83615
	],
	"./tabler/keyboard-off.svg": [
		54750,
		54750
	],
	"./tabler/keyboard-show.svg": [
		6612,
		6612
	],
	"./tabler/keyboard.svg": [
		98622,
		98622
	],
	"./tabler/language.svg": [
		68711,
		68711
	],
	"./tabler/layers-difference.svg": [
		43465,
		43465
	],
	"./tabler/layers-intersect.svg": [
		87039,
		87039
	],
	"./tabler/layers-linked.svg": [
		98915,
		98915
	],
	"./tabler/layers-subtract.svg": [
		71316,
		71316
	],
	"./tabler/layers-union.svg": [
		63101,
		63101
	],
	"./tabler/layout-2.svg": [
		97902,
		97902
	],
	"./tabler/layout-align-bottom.svg": [
		59293,
		59293
	],
	"./tabler/layout-align-center.svg": [
		77735,
		77735
	],
	"./tabler/layout-align-left.svg": [
		65087,
		65087
	],
	"./tabler/layout-align-middle.svg": [
		49883,
		49883
	],
	"./tabler/layout-align-right.svg": [
		23706,
		23706
	],
	"./tabler/layout-align-top.svg": [
		8245,
		8245
	],
	"./tabler/layout-bottombar.svg": [
		3072,
		3072
	],
	"./tabler/layout-cards.svg": [
		20473,
		20473
	],
	"./tabler/layout-columns.svg": [
		3901,
		3901
	],
	"./tabler/layout-distribute-horizontal.svg": [
		57798,
		57798
	],
	"./tabler/layout-distribute-vertical.svg": [
		22748,
		22748
	],
	"./tabler/layout-grid-add.svg": [
		1098,
		1098
	],
	"./tabler/layout-grid.svg": [
		56756,
		56756
	],
	"./tabler/layout-kanban.svg": [
		87185,
		87185
	],
	"./tabler/layout-list.svg": [
		9436,
		9436
	],
	"./tabler/layout-navbar.svg": [
		68762,
		68762
	],
	"./tabler/layout-rows.svg": [
		74707,
		74707
	],
	"./tabler/layout-sidebar-right.svg": [
		73201,
		73201
	],
	"./tabler/layout-sidebar.svg": [
		2272,
		2272
	],
	"./tabler/layout.svg": [
		61963,
		61963
	],
	"./tabler/leaf.svg": [
		92269,
		92269
	],
	"./tabler/lego.svg": [
		99338,
		99338
	],
	"./tabler/lemon.svg": [
		27166,
		27166
	],
	"./tabler/letter-a.svg": [
		85647,
		85647
	],
	"./tabler/letter-b.svg": [
		99676,
		99676
	],
	"./tabler/letter-c.svg": [
		11869,
		11869
	],
	"./tabler/letter-case-lower.svg": [
		81158,
		81158
	],
	"./tabler/letter-case-toggle.svg": [
		39087,
		39087
	],
	"./tabler/letter-case-upper.svg": [
		2789,
		2789
	],
	"./tabler/letter-case.svg": [
		13430,
		13430
	],
	"./tabler/letter-d.svg": [
		77938,
		77938
	],
	"./tabler/letter-e.svg": [
		81251,
		81251
	],
	"./tabler/letter-f.svg": [
		91856,
		91856
	],
	"./tabler/letter-g.svg": [
		82977,
		82977
	],
	"./tabler/letter-h.svg": [
		3177,
		25558
	],
	"./tabler/letter-i.svg": [
		72423,
		72423
	],
	"./tabler/letter-j.svg": [
		24212,
		24212
	],
	"./tabler/letter-k.svg": [
		45845,
		45845
	],
	"./tabler/letter-l.svg": [
		33098,
		33098
	],
	"./tabler/letter-m.svg": [
		85563,
		85563
	],
	"./tabler/letter-n.svg": [
		70024,
		70024
	],
	"./tabler/letter-o.svg": [
		82393,
		82393
	],
	"./tabler/letter-p.svg": [
		70926,
		70926
	],
	"./tabler/letter-q.svg": [
		85567,
		85567
	],
	"./tabler/letter-r.svg": [
		6540,
		6540
	],
	"./tabler/letter-s.svg": [
		53901,
		53901
	],
	"./tabler/letter-spacing.svg": [
		94697,
		94697
	],
	"./tabler/letter-t.svg": [
		25378,
		25378
	],
	"./tabler/letter-u.svg": [
		29107,
		29107
	],
	"./tabler/letter-v.svg": [
		84448,
		84448
	],
	"./tabler/letter-w.svg": [
		82481,
		82481
	],
	"./tabler/letter-x.svg": [
		31302,
		31302
	],
	"./tabler/letter-y.svg": [
		20279,
		20279
	],
	"./tabler/letter-z.svg": [
		65828,
		65828
	],
	"./tabler/letters-case.svg": [
		57333,
		57333
	],
	"./tabler/license.svg": [
		19334,
		19334
	],
	"./tabler/lifebuoy.svg": [
		90240,
		90240
	],
	"./tabler/line-dashed.svg": [
		17955,
		17955
	],
	"./tabler/line-dotted.svg": [
		37828,
		37828
	],
	"./tabler/line-height.svg": [
		54133,
		54133
	],
	"./tabler/line.svg": [
		86251,
		86251
	],
	"./tabler/link.svg": [
		74669,
		74669
	],
	"./tabler/list-check.svg": [
		630,
		630
	],
	"./tabler/list-numbers.svg": [
		85292,
		85292
	],
	"./tabler/list-search.svg": [
		80894,
		80894
	],
	"./tabler/list.svg": [
		90177,
		90177
	],
	"./tabler/live-photo.svg": [
		32688,
		32688
	],
	"./tabler/live-view.svg": [
		21663,
		21663
	],
	"./tabler/loader-quarter.svg": [
		98847,
		98847
	],
	"./tabler/loader.svg": [
		86200,
		86200
	],
	"./tabler/location.svg": [
		86108,
		86108
	],
	"./tabler/lock-access.svg": [
		94763,
		94763
	],
	"./tabler/lock-off.svg": [
		56568,
		56568
	],
	"./tabler/lock-open.svg": [
		98389,
		98389
	],
	"./tabler/lock.svg": [
		74612,
		74612
	],
	"./tabler/login.svg": [
		60280,
		60280
	],
	"./tabler/logout.svg": [
		72919,
		72919
	],
	"./tabler/macro.svg": [
		45531,
		45531
	],
	"./tabler/magnet.svg": [
		52151,
		52151
	],
	"./tabler/mail-forward.svg": [
		68768,
		68768
	],
	"./tabler/mail-opened.svg": [
		49122,
		49122
	],
	"./tabler/mail.svg": [
		88596,
		88596
	],
	"./tabler/mailbox.svg": [
		57847,
		57847
	],
	"./tabler/man.svg": [
		76591,
		76591
	],
	"./tabler/manual-gearbox.svg": [
		61012,
		61012
	],
	"./tabler/map-2.svg": [
		84000,
		84000
	],
	"./tabler/map-pin-off.svg": [
		31179,
		31179
	],
	"./tabler/map-pin.svg": [
		63683,
		63683
	],
	"./tabler/map-pins.svg": [
		2666,
		2666
	],
	"./tabler/map.svg": [
		41801,
		41801
	],
	"./tabler/markdown.svg": [
		26386,
		26386
	],
	"./tabler/marquee-2.svg": [
		69022,
		69022
	],
	"./tabler/marquee.svg": [
		60027,
		60027
	],
	"./tabler/mars.svg": [
		51426,
		51426
	],
	"./tabler/mask-off.svg": [
		19617,
		19617
	],
	"./tabler/mask.svg": [
		33501,
		33501
	],
	"./tabler/massage.svg": [
		77706,
		77706
	],
	"./tabler/math-function.svg": [
		81736,
		81736
	],
	"./tabler/math-symbols.svg": [
		63359,
		63359
	],
	"./tabler/math.svg": [
		90279,
		90279
	],
	"./tabler/maximize.svg": [
		52091,
		52091
	],
	"./tabler/meat.svg": [
		42024,
		42024
	],
	"./tabler/medal.svg": [
		56650,
		56650
	],
	"./tabler/medical-cross.svg": [
		98745,
		98745
	],
	"./tabler/menu-2.svg": [
		36817,
		36817
	],
	"./tabler/menu.svg": [
		68876,
		68876
	],
	"./tabler/message-2.svg": [
		19511,
		19511
	],
	"./tabler/message-circle-2.svg": [
		46910,
		46910
	],
	"./tabler/message-circle-off.svg": [
		61795,
		61795
	],
	"./tabler/message-circle.svg": [
		36123,
		36123
	],
	"./tabler/message-dots.svg": [
		43147,
		43147
	],
	"./tabler/message-off.svg": [
		16958,
		16958
	],
	"./tabler/message-plus.svg": [
		46903,
		46903
	],
	"./tabler/message-report.svg": [
		31697,
		31697
	],
	"./tabler/message.svg": [
		32126,
		32126
	],
	"./tabler/messages-off.svg": [
		90933,
		90933
	],
	"./tabler/messages.svg": [
		41953,
		41953
	],
	"./tabler/microphone-2.svg": [
		28664,
		28664
	],
	"./tabler/microphone-off.svg": [
		6245,
		6245
	],
	"./tabler/microphone.svg": [
		67505,
		67505
	],
	"./tabler/milk.svg": [
		68004,
		68004
	],
	"./tabler/minimize.svg": [
		89849,
		89849
	],
	"./tabler/minus-vertical.svg": [
		35866,
		35866
	],
	"./tabler/mist.svg": [
		45970,
		45970
	],
	"./tabler/mood-boy.svg": [
		26013,
		26013
	],
	"./tabler/mood-confuzed.svg": [
		85037,
		85037
	],
	"./tabler/mood-crazy-happy.svg": [
		68961,
		68961
	],
	"./tabler/mood-cry.svg": [
		81951,
		81951
	],
	"./tabler/mood-empty.svg": [
		19368,
		19368
	],
	"./tabler/mood-happy.svg": [
		26561,
		26561
	],
	"./tabler/mood-kid.svg": [
		22775,
		22775
	],
	"./tabler/mood-neutral.svg": [
		73398,
		73398
	],
	"./tabler/mood-sad.svg": [
		19479,
		19479
	],
	"./tabler/mood-smile.svg": [
		63255,
		63255
	],
	"./tabler/mood-suprised.svg": [
		28348,
		28348
	],
	"./tabler/mood-tongue.svg": [
		55173,
		55173
	],
	"./tabler/moon-2.svg": [
		79399,
		79399
	],
	"./tabler/moon-stars.svg": [
		15994,
		15994
	],
	"./tabler/moon.svg": [
		782,
		782
	],
	"./tabler/moped.svg": [
		58732,
		58732
	],
	"./tabler/motorbike.svg": [
		57935,
		57935
	],
	"./tabler/mouse.svg": [
		7789,
		30170
	],
	"./tabler/movie.svg": [
		72811,
		72811
	],
	"./tabler/mug.svg": [
		15602,
		15602
	],
	"./tabler/mushroom.svg": [
		79487,
		79487
	],
	"./tabler/music.svg": [
		71202,
		71202
	],
	"./tabler/new-section.svg": [
		44391,
		44391
	],
	"./tabler/news.svg": [
		34760,
		34760
	],
	"./tabler/nfc.svg": [
		45784,
		45784
	],
	"./tabler/note.svg": [
		77305,
		77305
	],
	"./tabler/notebook.svg": [
		68258,
		68258
	],
	"./tabler/notes.svg": [
		44984,
		44984
	],
	"./tabler/notification.svg": [
		64388,
		64388
	],
	"./tabler/number-0.svg": [
		82317,
		82317
	],
	"./tabler/number-1.svg": [
		83372,
		83372
	],
	"./tabler/number-2.svg": [
		62399,
		62399
	],
	"./tabler/number-3.svg": [
		33966,
		33966
	],
	"./tabler/number-4.svg": [
		32465,
		32465
	],
	"./tabler/number-5.svg": [
		96512,
		96512
	],
	"./tabler/number-6.svg": [
		17267,
		17267
	],
	"./tabler/number-7.svg": [
		12098,
		12098
	],
	"./tabler/number-8.svg": [
		56741,
		56741
	],
	"./tabler/number-9.svg": [
		5572,
		5572
	],
	"./tabler/octagon-off.svg": [
		83122,
		83122
	],
	"./tabler/octagon.svg": [
		33090,
		33090
	],
	"./tabler/old.svg": [
		33084,
		33084
	],
	"./tabler/olympics.svg": [
		79977,
		79977
	],
	"./tabler/omega.svg": [
		33606,
		33606
	],
	"./tabler/outlet.svg": [
		47710,
		47710
	],
	"./tabler/overline.svg": [
		15409,
		15409
	],
	"./tabler/package.svg": [
		96627,
		96627
	],
	"./tabler/pacman.svg": [
		34457,
		34457
	],
	"./tabler/page-break.svg": [
		36630,
		36630
	],
	"./tabler/paint.svg": [
		7035,
		7035
	],
	"./tabler/palette.svg": [
		94,
		94
	],
	"./tabler/panorama-horizontal.svg": [
		15169,
		15169
	],
	"./tabler/panorama-vertical.svg": [
		42695,
		42695
	],
	"./tabler/paperclip.svg": [
		76075,
		76075
	],
	"./tabler/parachute.svg": [
		32666,
		32666
	],
	"./tabler/parentheses.svg": [
		11275,
		11275
	],
	"./tabler/parking.svg": [
		77275,
		77275
	],
	"./tabler/peace.svg": [
		43913,
		43913
	],
	"./tabler/pencil.svg": [
		21142,
		21142
	],
	"./tabler/pennant.svg": [
		5995,
		5995
	],
	"./tabler/pepper.svg": [
		5481,
		5481
	],
	"./tabler/percentage.svg": [
		6257,
		6257
	],
	"./tabler/perspective.svg": [
		68653,
		68653
	],
	"./tabler/phone-call.svg": [
		76908,
		76908
	],
	"./tabler/phone-calling.svg": [
		2124,
		2124
	],
	"./tabler/phone-check.svg": [
		57252,
		57252
	],
	"./tabler/phone-incoming.svg": [
		79416,
		79416
	],
	"./tabler/phone-off.svg": [
		83147,
		83147
	],
	"./tabler/phone-outgoing.svg": [
		46782,
		46782
	],
	"./tabler/phone-pause.svg": [
		86018,
		86018
	],
	"./tabler/phone-plus.svg": [
		61948,
		61948
	],
	"./tabler/phone-x.svg": [
		43708,
		43708
	],
	"./tabler/phone.svg": [
		39299,
		39299
	],
	"./tabler/photo-off.svg": [
		32711,
		32711
	],
	"./tabler/photo.svg": [
		57135,
		57135
	],
	"./tabler/physotherapist.svg": [
		11821,
		34202
	],
	"./tabler/picture-in-picture-off.svg": [
		24150,
		24150
	],
	"./tabler/picture-in-picture-on.svg": [
		33376,
		33376
	],
	"./tabler/picture-in-picture.svg": [
		55766,
		55766
	],
	"./tabler/pill.svg": [
		92576,
		92576
	],
	"./tabler/pin.svg": [
		24814,
		24814
	],
	"./tabler/pinned-off.svg": [
		18327,
		18327
	],
	"./tabler/pinned.svg": [
		127,
		127
	],
	"./tabler/pizza.svg": [
		43565,
		43565
	],
	"./tabler/plane-arrival.svg": [
		95013,
		95013
	],
	"./tabler/plane-departure.svg": [
		74086,
		74086
	],
	"./tabler/plane.svg": [
		47617,
		47617
	],
	"./tabler/planet.svg": [
		41071,
		41071
	],
	"./tabler/plant-2.svg": [
		23309,
		23309
	],
	"./tabler/plant.svg": [
		49088,
		49088
	],
	"./tabler/play-card.svg": [
		45126,
		45126
	],
	"./tabler/play-circled-desktop.svg": [
		42435,
		42435
	],
	"./tabler/player-pause.svg": [
		26567,
		26567
	],
	"./tabler/player-play.svg": [
		36097,
		36097
	],
	"./tabler/player-record.svg": [
		33196,
		33196
	],
	"./tabler/player-skip-back.svg": [
		94374,
		94374
	],
	"./tabler/player-skip-forward.svg": [
		77134,
		77134
	],
	"./tabler/player-stop.svg": [
		8991,
		8991
	],
	"./tabler/player-track-next.svg": [
		63670,
		63670
	],
	"./tabler/player-track-prev.svg": [
		63754,
		63754
	],
	"./tabler/playlist.svg": [
		10039,
		10039
	],
	"./tabler/plug.svg": [
		5313,
		5313
	],
	"./tabler/point-filled.svg": [
		26738,
		26738
	],
	"./tabler/point.svg": [
		4481,
		4481
	],
	"./tabler/pokeball.svg": [
		40065,
		40065
	],
	"./tabler/polaroid.svg": [
		81381,
		81381
	],
	"./tabler/poo.svg": [
		75357,
		75357
	],
	"./tabler/pool.svg": [
		56307,
		56307
	],
	"./tabler/power.svg": [
		89740,
		89740
	],
	"./tabler/pray.svg": [
		26945,
		26945
	],
	"./tabler/presentation-analytics.svg": [
		50934,
		50934
	],
	"./tabler/presentation.svg": [
		79657,
		79657
	],
	"./tabler/printer.svg": [
		9367,
		9367
	],
	"./tabler/prompt.svg": [
		82707,
		82707
	],
	"./tabler/propeller.svg": [
		70558,
		70558
	],
	"./tabler/puzzle.svg": [
		78217,
		78217
	],
	"./tabler/pyramid.svg": [
		86967,
		86967
	],
	"./tabler/qrcode.svg": [
		55851,
		55851
	],
	"./tabler/question-mark.svg": [
		32693,
		32693
	],
	"./tabler/radio.svg": [
		35290,
		35290
	],
	"./tabler/radioactive.svg": [
		15096,
		15096
	],
	"./tabler/radius-bottom-left.svg": [
		39193,
		39193
	],
	"./tabler/radius-bottom-right.svg": [
		35460,
		35460
	],
	"./tabler/radius-top-left.svg": [
		82961,
		82961
	],
	"./tabler/radius-top-right.svg": [
		77372,
		77372
	],
	"./tabler/rainbow.svg": [
		27485,
		27485
	],
	"./tabler/receipt-2.svg": [
		19282,
		19282
	],
	"./tabler/receipt-off.svg": [
		57343,
		57343
	],
	"./tabler/receipt-refund.svg": [
		92878,
		92878
	],
	"./tabler/receipt-tax.svg": [
		55079,
		55079
	],
	"./tabler/receipt.svg": [
		18535,
		18535
	],
	"./tabler/recharging.svg": [
		49607,
		49607
	],
	"./tabler/record-mail.svg": [
		21434,
		21434
	],
	"./tabler/rectangle-vertical.svg": [
		86467,
		86467
	],
	"./tabler/rectangle.svg": [
		49264,
		49264
	],
	"./tabler/recycle.svg": [
		34420,
		34420
	],
	"./tabler/refresh-alert.svg": [
		26471,
		26471
	],
	"./tabler/refresh.svg": [
		69754,
		69754
	],
	"./tabler/registered.svg": [
		50957,
		50957
	],
	"./tabler/relation-many-to-many.svg": [
		16225,
		16225
	],
	"./tabler/relation-one-to-many.svg": [
		57308,
		57308
	],
	"./tabler/relation-one-to-one.svg": [
		35291,
		35291
	],
	"./tabler/repeat-once.svg": [
		24146,
		24146
	],
	"./tabler/repeat.svg": [
		77516,
		77516
	],
	"./tabler/replace.svg": [
		36335,
		36335
	],
	"./tabler/report-analytics.svg": [
		1696,
		1696
	],
	"./tabler/report-medical.svg": [
		73677,
		73677
	],
	"./tabler/report-money.svg": [
		66092,
		66092
	],
	"./tabler/report.svg": [
		735,
		735
	],
	"./tabler/resize.svg": [
		99793,
		99793
	],
	"./tabler/ripple.svg": [
		70571,
		70571
	],
	"./tabler/road-sign.svg": [
		44103,
		44103
	],
	"./tabler/rocket.svg": [
		47937,
		47937
	],
	"./tabler/rotate-2.svg": [
		53365,
		53365
	],
	"./tabler/rotate-clockwise-2.svg": [
		26416,
		26416
	],
	"./tabler/rotate-clockwise.svg": [
		92537,
		92537
	],
	"./tabler/rotate-rectangle.svg": [
		59004,
		59004
	],
	"./tabler/rotate.svg": [
		6296,
		6296
	],
	"./tabler/route.svg": [
		63016,
		63016
	],
	"./tabler/router.svg": [
		59242,
		59242
	],
	"./tabler/row-insert-bottom.svg": [
		22845,
		22845
	],
	"./tabler/row-insert-top.svg": [
		39701,
		39701
	],
	"./tabler/rss.svg": [
		7195,
		7195
	],
	"./tabler/ruler-2.svg": [
		77386,
		77386
	],
	"./tabler/ruler.svg": [
		91727,
		91727
	],
	"./tabler/run.svg": [
		764,
		764
	],
	"./tabler/sailboat.svg": [
		78796,
		78796
	],
	"./tabler/salt.svg": [
		74897,
		74897
	],
	"./tabler/satellite.svg": [
		72824,
		72824
	],
	"./tabler/sausage.svg": [
		60198,
		60198
	],
	"./tabler/scale.svg": [
		92017,
		92017
	],
	"./tabler/scan.svg": [
		44134,
		44134
	],
	"./tabler/school.svg": [
		45693,
		45693
	],
	"./tabler/scissors.svg": [
		56472,
		56472
	],
	"./tabler/scooter-electric.svg": [
		18938,
		18938
	],
	"./tabler/scooter.svg": [
		36934,
		36934
	],
	"./tabler/screen-share-off.svg": [
		84279,
		84279
	],
	"./tabler/screen-share.svg": [
		11615,
		11615
	],
	"./tabler/scuba-mask.svg": [
		33780,
		33780
	],
	"./tabler/search-no-results.svg": [
		17374,
		17374
	],
	"./tabler/search.svg": [
		9153,
		9153
	],
	"./tabler/section.svg": [
		8938,
		8938
	],
	"./tabler/seeding.svg": [
		47385,
		69766
	],
	"./tabler/select.svg": [
		58969,
		58969
	],
	"./tabler/selector.svg": [
		45958,
		45958
	],
	"./tabler/send.svg": [
		50519,
		50519
	],
	"./tabler/separator-horizontal.svg": [
		53623,
		53623
	],
	"./tabler/separator-vertical.svg": [
		75301,
		75301
	],
	"./tabler/separator.svg": [
		21154,
		21154
	],
	"./tabler/server.svg": [
		73528,
		73528
	],
	"./tabler/servicemark.svg": [
		22109,
		22109
	],
	"./tabler/settings-automation.svg": [
		90266,
		90266
	],
	"./tabler/settings.svg": [
		50146,
		50146
	],
	"./tabler/shadow-off.svg": [
		5757,
		5757
	],
	"./tabler/shadow.svg": [
		67753,
		67753
	],
	"./tabler/shape-2.svg": [
		57529,
		57529
	],
	"./tabler/shape-3.svg": [
		92136,
		92136
	],
	"./tabler/shape.svg": [
		79652,
		79652
	],
	"./tabler/share.svg": [
		42638,
		42638
	],
	"./tabler/shield-check.svg": [
		5709,
		5709
	],
	"./tabler/shield-lock.svg": [
		11062,
		11062
	],
	"./tabler/shield-off.svg": [
		62894,
		62894
	],
	"./tabler/shield-x.svg": [
		55133,
		55133
	],
	"./tabler/shield.svg": [
		42382,
		42382
	],
	"./tabler/ship.svg": [
		3563,
		3563
	],
	"./tabler/shirt.svg": [
		69511,
		69511
	],
	"./tabler/shopping-cart-discount.svg": [
		92280,
		92280
	],
	"./tabler/shopping-cart-off.svg": [
		63708,
		63708
	],
	"./tabler/shopping-cart-plus.svg": [
		38097,
		38097
	],
	"./tabler/shopping-cart-x.svg": [
		72591,
		72591
	],
	"./tabler/shopping-cart.svg": [
		55512,
		55512
	],
	"./tabler/shredder.svg": [
		34542,
		34542
	],
	"./tabler/signature.svg": [
		48605,
		48605
	],
	"./tabler/sitemap.svg": [
		2722,
		2722
	],
	"./tabler/skateboard.svg": [
		75299,
		75299
	],
	"./tabler/slice.svg": [
		20817,
		20817
	],
	"./tabler/slideshow.svg": [
		22959,
		22959
	],
	"./tabler/smart-home.svg": [
		99992,
		99992
	],
	"./tabler/smoking-no.svg": [
		24431,
		24431
	],
	"./tabler/smoking.svg": [
		70333,
		70333
	],
	"./tabler/snowflake.svg": [
		52027,
		52027
	],
	"./tabler/soccer-field.svg": [
		57587,
		57587
	],
	"./tabler/social.svg": [
		50740,
		50740
	],
	"./tabler/sock.svg": [
		26217,
		26217
	],
	"./tabler/sort-ascending-2.svg": [
		31185,
		31185
	],
	"./tabler/sort-ascending-letters.svg": [
		54940,
		54940
	],
	"./tabler/sort-ascending-numbers.svg": [
		40625,
		40625
	],
	"./tabler/sort-ascending.svg": [
		82412,
		82412
	],
	"./tabler/sort-descending-2.svg": [
		28797,
		28797
	],
	"./tabler/sort-descending-letters.svg": [
		3680,
		3680
	],
	"./tabler/sort-descending-numbers.svg": [
		67805,
		67805
	],
	"./tabler/sort-descending.svg": [
		38096,
		38096
	],
	"./tabler/soup.svg": [
		34992,
		34992
	],
	"./tabler/space.svg": [
		10117,
		10117
	],
	"./tabler/speakerphone.svg": [
		62932,
		62932
	],
	"./tabler/speedboat.svg": [
		14388,
		14388
	],
	"./tabler/sport-billard.svg": [
		88392,
		88392
	],
	"./tabler/square-0.svg": [
		88283,
		88283
	],
	"./tabler/square-1.svg": [
		46314,
		46314
	],
	"./tabler/square-2.svg": [
		72313,
		72313
	],
	"./tabler/square-3.svg": [
		6920,
		6920
	],
	"./tabler/square-4.svg": [
		44519,
		44519
	],
	"./tabler/square-5.svg": [
		4982,
		4982
	],
	"./tabler/square-6.svg": [
		17941,
		17941
	],
	"./tabler/square-7.svg": [
		56660,
		56660
	],
	"./tabler/square-8.svg": [
		30051,
		30051
	],
	"./tabler/square-9.svg": [
		80658,
		80658
	],
	"./tabler/square-check.svg": [
		77847,
		77847
	],
	"./tabler/square-dot.svg": [
		97890,
		97890
	],
	"./tabler/square-forbid-2.svg": [
		95638,
		95638
	],
	"./tabler/square-forbid.svg": [
		4099,
		4099
	],
	"./tabler/square-minus.svg": [
		13579,
		13579
	],
	"./tabler/square-off.svg": [
		18728,
		18728
	],
	"./tabler/square-plus.svg": [
		82557,
		82557
	],
	"./tabler/square-root-2.svg": [
		97316,
		97316
	],
	"./tabler/square-root.svg": [
		36725,
		36725
	],
	"./tabler/square-rotated-off.svg": [
		43816,
		43816
	],
	"./tabler/square-rotated.svg": [
		99844,
		99844
	],
	"./tabler/square-toggle-horizontal.svg": [
		92214,
		92214
	],
	"./tabler/square-toggle.svg": [
		97629,
		97629
	],
	"./tabler/square-x.svg": [
		57123,
		57123
	],
	"./tabler/square.svg": [
		37956,
		37956
	],
	"./tabler/squares-diagonal.svg": [
		9221,
		9221
	],
	"./tabler/squares-filled.svg": [
		40176,
		40176
	],
	"./tabler/stack-2.svg": [
		17394,
		17394
	],
	"./tabler/stack.svg": [
		53383,
		53383
	],
	"./tabler/stairs-down.svg": [
		8072,
		8072
	],
	"./tabler/stairs-up.svg": [
		23611,
		23611
	],
	"./tabler/stairs.svg": [
		41395,
		41395
	],
	"./tabler/star-half.svg": [
		31129,
		31129
	],
	"./tabler/star-off.svg": [
		55689,
		55689
	],
	"./tabler/star.svg": [
		49317,
		49317
	],
	"./tabler/stars.svg": [
		30092,
		30092
	],
	"./tabler/steering-wheel.svg": [
		31746,
		31746
	],
	"./tabler/step-into.svg": [
		69690,
		69690
	],
	"./tabler/step-out.svg": [
		83168,
		83168
	],
	"./tabler/stethoscope.svg": [
		63532,
		63532
	],
	"./tabler/sticker.svg": [
		29666,
		29666
	],
	"./tabler/strikethrough.svg": [
		53850,
		53850
	],
	"./tabler/submarine.svg": [
		32427,
		32427
	],
	"./tabler/subscript.svg": [
		88728,
		88728
	],
	"./tabler/subtask.svg": [
		96802,
		96802
	],
	"./tabler/sum.svg": [
		94698,
		94698
	],
	"./tabler/sun-off.svg": [
		23725,
		23725
	],
	"./tabler/sun.svg": [
		39097,
		39097
	],
	"./tabler/sunrise.svg": [
		86778,
		86778
	],
	"./tabler/sunset.svg": [
		94883,
		94883
	],
	"./tabler/superscript.svg": [
		83599,
		83599
	],
	"./tabler/swimming.svg": [
		72626,
		72626
	],
	"./tabler/switch-2.svg": [
		78720,
		78720
	],
	"./tabler/switch-3.svg": [
		76753,
		76753
	],
	"./tabler/switch-horizontal.svg": [
		85402,
		85402
	],
	"./tabler/switch-vertical.svg": [
		67896,
		67896
	],
	"./tabler/switch.svg": [
		44265,
		44265
	],
	"./tabler/table-export.svg": [
		43058,
		43058
	],
	"./tabler/table-import.svg": [
		5927,
		5927
	],
	"./tabler/table-off.svg": [
		2703,
		2703
	],
	"./tabler/table.svg": [
		55671,
		55671
	],
	"./tabler/tag.svg": [
		803,
		803
	],
	"./tabler/tallymark-1.svg": [
		37804,
		37804
	],
	"./tabler/tallymark-2.svg": [
		16831,
		16831
	],
	"./tabler/tallymark-3.svg": [
		2190,
		2190
	],
	"./tabler/tallymark-4.svg": [
		13745,
		13745
	],
	"./tabler/tallymarks.svg": [
		15241,
		15241
	],
	"./tabler/tank.svg": [
		93389,
		93389
	],
	"./tabler/target.svg": [
		38266,
		38266
	],
	"./tabler/temperature-celsius.svg": [
		48102,
		48102
	],
	"./tabler/temperature-fahrenheit.svg": [
		73576,
		73576
	],
	"./tabler/temperature-minus.svg": [
		92854,
		92854
	],
	"./tabler/temperature-plus.svg": [
		94366,
		94366
	],
	"./tabler/temperature.svg": [
		26453,
		26453
	],
	"./tabler/template.svg": [
		771,
		771
	],
	"./tabler/tent.svg": [
		15118,
		15118
	],
	"./tabler/terminal-2.svg": [
		35284,
		35284
	],
	"./tabler/terminal.svg": [
		37189,
		37189
	],
	"./tabler/test-pipe.svg": [
		74974,
		74974
	],
	"./tabler/text-direction-ltr.svg": [
		67161,
		67161
	],
	"./tabler/text-direction-rtl.svg": [
		48953,
		48953
	],
	"./tabler/text-wrap-disabled.svg": [
		68734,
		68734
	],
	"./tabler/text-wrap.svg": [
		15649,
		15649
	],
	"./tabler/thumb-down.svg": [
		47606,
		92368
	],
	"./tabler/thumb-up.svg": [
		57955,
		57955
	],
	"./tabler/ticket.svg": [
		86257,
		86257
	],
	"./tabler/tilt-shift.svg": [
		55819,
		55819
	],
	"./tabler/timeline-event-plus.svg": [
		3800,
		3800
	],
	"./tabler/tir.svg": [
		39750,
		39750
	],
	"./tabler/toggle-left.svg": [
		87569,
		87569
	],
	"./tabler/toggle-right.svg": [
		67548,
		67548
	],
	"./tabler/tool.svg": [
		8303,
		8303
	],
	"./tabler/tools-kitchen-2.svg": [
		9028,
		9028
	],
	"./tabler/tools-kitchen.svg": [
		87285,
		87285
	],
	"./tabler/tools.svg": [
		52110,
		52110
	],
	"./tabler/tornado.svg": [
		21287,
		43668
	],
	"./tabler/tournament.svg": [
		29928,
		29928
	],
	"./tabler/track.svg": [
		79382,
		79382
	],
	"./tabler/tractor.svg": [
		56718,
		56718
	],
	"./tabler/trademark.svg": [
		2518,
		2518
	],
	"./tabler/traffic-cone.svg": [
		21896,
		21896
	],
	"./tabler/traffic-lights.svg": [
		61018,
		61018
	],
	"./tabler/train.svg": [
		72169,
		72169
	],
	"./tabler/transfer-in.svg": [
		48268,
		48268
	],
	"./tabler/transfer-out.svg": [
		37203,
		37203
	],
	"./tabler/trash-off.svg": [
		40649,
		40649
	],
	"./tabler/trash.svg": [
		40261,
		40261
	],
	"./tabler/tree.svg": [
		7365,
		7365
	],
	"./tabler/trees.svg": [
		6956,
		6956
	],
	"./tabler/trending-down-2.svg": [
		93574,
		93574
	],
	"./tabler/trending-down-3.svg": [
		81111,
		81111
	],
	"./tabler/trending-down.svg": [
		44179,
		44179
	],
	"./tabler/trending-up-2.svg": [
		91473,
		91473
	],
	"./tabler/trending-up-3.svg": [
		93440,
		93440
	],
	"./tabler/trending-up.svg": [
		13388,
		13388
	],
	"./tabler/triangle-off.svg": [
		94137,
		94137
	],
	"./tabler/triangle-square-circle.svg": [
		28356,
		28356
	],
	"./tabler/triangle.svg": [
		38261,
		38261
	],
	"./tabler/trident.svg": [
		49399,
		49399
	],
	"./tabler/trophy.svg": [
		32943,
		32943
	],
	"./tabler/truck-delivery.svg": [
		12571,
		12571
	],
	"./tabler/truck-off.svg": [
		49194,
		49194
	],
	"./tabler/truck-return.svg": [
		32657,
		32657
	],
	"./tabler/truck.svg": [
		80090,
		80090
	],
	"./tabler/typography.svg": [
		72394,
		72394
	],
	"./tabler/umbrella.svg": [
		4905,
		4905
	],
	"./tabler/underline.svg": [
		18727,
		18727
	],
	"./tabler/unlink.svg": [
		97340,
		97340
	],
	"./tabler/upload.svg": [
		12650,
		12650
	],
	"./tabler/urgent.svg": [
		38414,
		38414
	],
	"./tabler/user-check.svg": [
		62043,
		62043
	],
	"./tabler/user-exclamation.svg": [
		42992,
		42992
	],
	"./tabler/user-minus.svg": [
		72959,
		72959
	],
	"./tabler/user-off.svg": [
		46044,
		46044
	],
	"./tabler/user-plus.svg": [
		70513,
		70513
	],
	"./tabler/user-x.svg": [
		76335,
		76335
	],
	"./tabler/user.svg": [
		25080,
		25080
	],
	"./tabler/users.svg": [
		3435,
		3435
	],
	"./tabler/vaccine.svg": [
		14298,
		14298
	],
	"./tabler/variable.svg": [
		14421,
		14421
	],
	"./tabler/vector-beizer-2.svg": [
		74435,
		74435
	],
	"./tabler/vector-bezier.svg": [
		2204,
		2204
	],
	"./tabler/vector-triangle.svg": [
		41569,
		41569
	],
	"./tabler/vector.svg": [
		58568,
		58568
	],
	"./tabler/venus.svg": [
		7612,
		7612
	],
	"./tabler/versions.svg": [
		49582,
		49582
	],
	"./tabler/video-minus.svg": [
		80521,
		80521
	],
	"./tabler/video-off.svg": [
		9202,
		9202
	],
	"./tabler/video-plus.svg": [
		79835,
		79835
	],
	"./tabler/video.svg": [
		19042,
		19042
	],
	"./tabler/view-360.svg": [
		25400,
		25400
	],
	"./tabler/viewfinder.svg": [
		33534,
		33534
	],
	"./tabler/viewport-narrow.svg": [
		66646,
		66646
	],
	"./tabler/viewport-wide.svg": [
		513,
		513
	],
	"./tabler/virus-off.svg": [
		62640,
		62640
	],
	"./tabler/virus-search.svg": [
		29449,
		29449
	],
	"./tabler/virus.svg": [
		34060,
		34060
	],
	"./tabler/vocabulary.svg": [
		76865,
		76865
	],
	"./tabler/volume-2.svg": [
		6554,
		6554
	],
	"./tabler/volume-3.svg": [
		25611,
		25611
	],
	"./tabler/volume.svg": [
		43839,
		43839
	],
	"./tabler/walk.svg": [
		72642,
		72642
	],
	"./tabler/wallet-disabled.svg": [
		97363,
		97363
	],
	"./tabler/wallet.svg": [
		20330,
		20330
	],
	"./tabler/wand.svg": [
		80831,
		80831
	],
	"./tabler/wave-saw-tool.svg": [
		77781,
		77781
	],
	"./tabler/wave-sine.svg": [
		90136,
		90136
	],
	"./tabler/wave-square.svg": [
		22082,
		22082
	],
	"./tabler/wifi-0.svg": [
		89017,
		89017
	],
	"./tabler/wifi-1.svg": [
		81096,
		81096
	],
	"./tabler/wifi-2.svg": [
		62459,
		62459
	],
	"./tabler/wifi-off.svg": [
		81066,
		81066
	],
	"./tabler/wifi.svg": [
		29146,
		29146
	],
	"./tabler/wind.svg": [
		98439,
		98439
	],
	"./tabler/windmill.svg": [
		24969,
		24969
	],
	"./tabler/window.svg": [
		74721,
		74721
	],
	"./tabler/wiper-wash.svg": [
		28222,
		28222
	],
	"./tabler/wiper.svg": [
		90098,
		90098
	],
	"./tabler/woman.svg": [
		6737,
		6737
	],
	"./tabler/world-latitude.svg": [
		83924,
		83924
	],
	"./tabler/world-longitude.svg": [
		10603,
		10603
	],
	"./tabler/world.svg": [
		26443,
		26443
	],
	"./tabler/wrecking-ball.svg": [
		64495,
		64495
	],
	"./tabler/writing-sign.svg": [
		98071,
		98071
	],
	"./tabler/writing.svg": [
		92979,
		92979
	],
	"./tabler/x.svg": [
		32627,
		32627
	],
	"./tabler/yin-yang.svg": [
		63531,
		63531
	],
	"./tabler/zodiac-aquarius.svg": [
		16053,
		16053
	],
	"./tabler/zodiac-aries.svg": [
		87160,
		87160
	],
	"./tabler/zodiac-cancer.svg": [
		72082,
		72082
	],
	"./tabler/zodiac-capricorn.svg": [
		66207,
		66207
	],
	"./tabler/zodiac-gemini.svg": [
		66511,
		66511
	],
	"./tabler/zodiac-leo.svg": [
		60126,
		60126
	],
	"./tabler/zodiac-libra.svg": [
		83780,
		83780
	],
	"./tabler/zodiac-pisces.svg": [
		6125,
		6125
	],
	"./tabler/zodiac-sagittarius.svg": [
		35103,
		57484
	],
	"./tabler/zodiac-scorpio.svg": [
		44753,
		44753
	],
	"./tabler/zodiac-taurus.svg": [
		1154,
		1154
	],
	"./tabler/zodiac-virgo.svg": [
		96611,
		96611
	],
	"./tabler/zoom-cancel.svg": [
		51495,
		51495
	],
	"./tabler/zoom-check.svg": [
		66647,
		66647
	],
	"./tabler/zoom-in.svg": [
		93912,
		93912
	],
	"./tabler/zoom-money.svg": [
		14691,
		14691
	],
	"./tabler/zoom-out.svg": [
		12343,
		12343
	],
	"./tabler/zoom-question.svg": [
		73565,
		73565
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 39715;
module.exports = webpackAsyncContext;